import { render } from "./TheProduction.vue?vue&type=template&id=1c9042e5&scoped=true&lang=true"
import script from "./TheProduction.vue?vue&type=script&lang=js"
export * from "./TheProduction.vue?vue&type=script&lang=js"

import "./TheProduction.vue?vue&type=style&index=0&id=1c9042e5&lang=scss&scoped=true"

import exportComponent from "/home/ajdin/forspace-web/forspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c9042e5"]])

export default __exports__